var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.primaryCountry
    ? _c(
        "FormGroup",
        {
          class: _vm.groupClasses,
          attrs: {
            title: _vm.title,
            errors: _vm.errors,
            type: "search",
            disabled: _vm.disabled,
          },
        },
        [
          _c("StateProvinceSelect", {
            attrs: {
              multiple: _vm.multiple,
              countries: _vm.countries,
              getcontainerStyle: "customFullWidthInput",
              disabled: _vm.disabled,
              title: _vm.title,
              inputClass: _vm.shouldFullWidth,
              searchable: "",
            },
            model: {
              value: _vm.stateOption,
              callback: function ($$v) {
                _vm.stateOption = $$v
              },
              expression: "stateOption",
            },
          }),
        ],
        1
      )
    : _c("FormGroup", {
        class: _vm.groupClasses,
        attrs: {
          type: "search",
          placeholder: _vm.placeholderText,
          isIcon: _vm.isIcon,
          title: _vm.title,
          inputClass: _vm.shouldFullWidth,
          disabled: _vm.disabled,
        },
        on: { enter: _vm.handleEnter },
        model: {
          value: _vm.region,
          callback: function ($$v) {
            _vm.region = $$v
          },
          expression: "region",
        },
      })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }